import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=07068569&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07068569')) {
      api.createRecord('07068569', component.options)
    } else {
      api.reload('07068569', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=07068569&", function () {
      api.rerender('07068569', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vendor/vue-medialibrary/src/components/Loader.vue"
export default component.exports